export default {
  custom: {
    agreePrivacyPolicy: {
      required: 'Az adatvédelmi tájékoztató elfogadása kötelező.'
    },
    agreeTermsOfService: {
      required: 'Az általános szerződési feltételek elfogadása kötelező.'
    },
    'skills[it]': {
      itSkills: 'A számítástechnikai ismeretek megadása kötelező.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/hu/custom-messages.js